module.exports = __webpack_public_path__ + "static/bar01_4-d179f8d50d7f093bec5031dc728ede58.png";